import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { SessionOffGuard } from './guards/session-off.guard';
import { SessionOnGuard } from './guards/session-on.guard';
import { VerificarPrivilegiosGuard } from './guards/verificar-privilegios.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () =>
      import('./paginas/home/home.module').then((m) => m.HomePageModule),
    canActivate: [SessionOnGuard],
  },

  {
    path: 'folder/:id',
    loadChildren: () =>
      import('./folder/folder.module').then((m) => m.FolderPageModule),
  },
  {
    path: 'login',
    loadChildren: () =>
      import('./paginas/login/login.module').then((m) => m.LoginPageModule),
    canActivate: [SessionOffGuard],
  },
  {
    path: 'login/:tokenf',
    loadChildren: () =>
      import('./paginas/login/login.module').then((m) => m.LoginPageModule),
    canActivate: [SessionOffGuard],
  },
  {
    path: 'home',
    loadChildren: () =>
      import('./paginas/home/home.module').then((m) => m.HomePageModule),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'circulares',
    loadChildren: () =>
      import('./paginas/circulares/circulares.module').then(
        (m) => m.CircularesPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'estudiantes',
    loadChildren: () =>
      import('./paginas/estudiantes/estudiantes.module').then(
        (m) => m.EstudiantesPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'calendario',
    loadChildren: () =>
      import('./paginas/calendario/calendario.module').then(
        (m) => m.CalendarioPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'apadavi',
    loadChildren: () =>
      import('./paginas/apadavi/apadavi.module').then(
        (m) => m.ApadaviPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'horarios',
    loadChildren: () =>
      import('./paginas/horarios/horarios.module').then(
        (m) => m.HorariosPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'registro',
    loadChildren: () =>
      import('./paginas/registro/registro.module').then(
        (m) => m.RegistroPageModule
      ),
    canActivate: [SessionOffGuard],
  },
  {
    path: 'registro/Code/:QRCode',
    loadChildren: () =>
      import('./paginas/registro/registro.module').then(
        (m) => m.RegistroPageModule
      ),
    canActivate: [SessionOffGuard],
  },
  {
    path: 'admin-dash',
    loadChildren: () =>
      import('./paginas/admin-dash/admin-dash.module').then(
        (m) => m.AdminDashPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: '404',
    loadChildren: () =>
      import('./paginas/p404/p404.module').then((m) => m.P404PageModule),
  },
  {
    path: 'recuperar-password/:token',
    loadChildren: () =>
      import('./paginas/recuperar-password/recuperar-password.module').then(
        (m) => m.RecuperarPasswordPageModule
      ),
    canActivate: [SessionOffGuard],
  },

  {
    path: 'familias',
    loadChildren: () =>
      import('./paginas/familias/familias.module').then(
        (m) => m.FamiliasPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'familia/:CodigoFamilia',
    loadChildren: () =>
      import('./paginas/familia/familia.module').then(
        (m) => m.FamiliaPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'usuarios',
    loadChildren: () =>
      import('./paginas/usuarios/usuarios.module').then(
        (m) => m.UsuariosPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'usuario/:UserID',
    loadChildren: () =>
      import('./paginas/usuario/usuario.module').then(
        (m) => m.UsuarioPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'pdf',
    loadChildren: () =>
      import('./paginas/pdf/pdf.module').then((m) => m.PdfPageModule),
  },
  {
    path: 'roles',
    loadChildren: () =>
      import('./paginas/roles/roles.module').then((m) => m.RolesPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'adm-calendario',
    loadChildren: () =>
      import('./paginas/adm-calendario/adm-calendario.module').then(
        (m) => m.AdmCalendarioPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'adm-comunicados',
    loadChildren: () =>
      import('./paginas/adm-comunicados/adm-comunicados.module').then(
        (m) => m.AdmComunicadosPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'documento-cod-familia',
    loadChildren: () =>
      import(
        './paginas/documento-cod-familia/documento-cod-familia.module'
      ).then((m) => m.DocumentoCodFamiliaPageModule),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'config-calificaciones',
    loadChildren: () =>
      import(
        './paginas/config-calificaciones/config-calificaciones.module'
      ).then((m) => m.ConfigCalificacionesPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'config-horarios',
    loadChildren: () =>
      import('./paginas/config-horarios/config-horarios.module').then(
        (m) => m.ConfigHorariosPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'config-actividades',
    loadChildren: () =>
      import('./paginas/config-actividades/config-actividades.module').then(
        (m) => m.ConfigActividadesPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'perfil',
    loadChildren: () =>
      import('./paginas/perfil/perfil.module').then((m) => m.PerfilPageModule),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'pagos-consultas',
    loadChildren: () =>
      import('./paginas/pagos-consultas/pagos-consultas.module').then(
        (m) => m.PagosConsultasPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'comunicado/:id',
    loadChildren: () =>
      import('./paginas/comunicado/comunicado.module').then(
        (m) => m.ComunicadoPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'hijo/:num',
    loadChildren: () =>
      import('./paginas/hijo/hijo.module').then((m) => m.HijoPageModule),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'calificaciones/:num',
    loadChildren: () =>
      import('./paginas/calificaciones/calificaciones.module').then(
        (m) => m.CalificacionesPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'calificaciones/:num/:IdEst',
    loadChildren: () =>
      import('./paginas/calificaciones/calificaciones.module').then(
        (m) => m.CalificacionesPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'reportes-progreso/:num',
    loadChildren: () =>
      import('./paginas/reportes-progreso/reportes-progreso.module').then(
        (m) => m.ReportesProgresoPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'reportes-progreso/:num/:IdEst',
    loadChildren: () =>
      import('./paginas/reportes-progreso/reportes-progreso.module').then(
        (m) => m.ReportesProgresoPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'configuracion',
    loadChildren: () =>
      import('./paginas/configuracion/configuracion.module').then(
        (m) => m.ConfiguracionPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'perfil-hijo/:num',
    loadChildren: () =>
      import('./paginas/perfil-hijo/perfil-hijo.module').then(
        (m) => m.PerfilHijoPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'cambiar-password',
    loadChildren: () =>
      import('./paginas/cambiar-password/cambiar-password.module').then(
        (m) => m.CambiarPasswordPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'actividades',
    loadChildren: () =>
      import('./paginas/actividades/actividades.module').then(
        (m) => m.ActividadesPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'actividad/:Id',
    loadChildren: () =>
      import('./paginas/actividad/actividad.module').then(
        (m) => m.ActividadPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'adm-configuraciones',
    loadChildren: () =>
      import('./paginas/adm-configuraciones/adm-configuraciones.module').then(
        (m) => m.AdmConfiguracionesPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'pagos',
    loadChildren: () =>
      import('./paginas/pagos/pagos.module').then((m) => m.PagosPageModule),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'pago',
    loadChildren: () =>
      import('./paginas/pagos/pagos.module').then((m) => m.PagosPageModule),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'pagos/:d',
    loadChildren: () =>
      import('./paginas/pagos/pagos.module').then((m) => m.PagosPageModule),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'contactanos',
    loadChildren: () =>
      import('./paginas/contactanos/contactanos.module').then(
        (m) => m.ContactanosPageModule
      ),
    canActivate: [SessionOnGuard],
  },

  {
    path: 'adm-notificaciones',
    loadChildren: () =>
      import('./paginas/adm-notificaciones/adm-notificaciones.module').then(
        (m) => m.AdmNotificacionesPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'registro-tarjeta',
    loadChildren: () =>
      import('./paginas/registro-tarjeta/registro-tarjeta.module').then(
        (m) => m.RegistroTarjetaPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'registro-tarjeta/:checkout',
    loadChildren: () =>
      import('./paginas/registro-tarjeta/registro-tarjeta.module').then(
        (m) => m.RegistroTarjetaPageModule
      ),
    canActivate: [SessionOnGuard],
  },
  {
    path: 'checkout',
    loadChildren: () =>
      import('./paginas/checkout/checkout.module').then(
        (m) => m.CheckoutPageModule
      ),
    canActivate: [SessionOnGuard],
  },

  {
    path: 'nohup',
    loadChildren: () =>
      import('./paginas/nohup/nohup.module').then((m) => m.NohupPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'logs',
    loadChildren: () =>
      import('./paginas/logs/logs.module').then((m) => m.LogsPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'adm-detalles-pagos',
    loadChildren: () =>
      import('./paginas/adm-detalles-pagos/adm-detalles-pagos.module').then(
        (m) => m.AdmDetallesPagosPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'adm-reportes-evaluacion',
    loadChildren: () =>
      import(
        './paginas/adm-reportes-evaluacion/adm-reportes-evaluacion.module'
      ).then((m) => m.AdmReportesEvaluacionPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'graficos',
    loadChildren: () =>
      import('./paginas/graficos/graficos.module').then(
        (m) => m.GraficosPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'adm-log-tarjetas',
    loadChildren: () =>
      import('./paginas/adm-log-tarjetas/adm-log-tarjetas.module').then(
        (m) => m.AdmLogTarjetasPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'llenar-indicadores',
    loadChildren: () =>
      import('./paginas/llenar-indicadores/llenar-indicadores.module').then(
        (m) => m.LlenarIndicadoresPageModule
      ), canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'llenar-indicadores/:datos',
    loadChildren: () =>
      import('./paginas/llenar-indicadores/llenar-indicadores.module').then(
        (m) => m.LlenarIndicadoresPageModule
      ), canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
    {
    path: 'llenar-indicadores/:IdSeccion',
    loadChildren: () =>
      import('./paginas/llenar-indicadores/llenar-indicadores.module').then(
        (m) => m.LlenarIndicadoresPageModule
      ), canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'indicadores-listado-secciones',
    loadChildren: () =>
      import(
        './paginas/indicadores-listado-secciones/indicadores-listado-secciones.module'
      ).then((m) => m.IndicadoresListadoSeccionesPageModule), 
      canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'funciones-dash',
    loadChildren: () =>
      import('./paginas/funciones-dash/funciones-dash.module').then(
        (m) => m.FuncionesDashPageModule
      ),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  
  {
    path: 'cancelar-suscripcion-notificaciones-correo/:token',
    loadChildren: () => import('./paginas/cancelar-suscripcion-notificaciones-correo/cancelar-suscripcion-notificaciones-correo.module').then( m => m.CancelarSuscripcionNotificacionesCorreoPageModule)
  },

  
  {
    path: 'indicadores-asignatura-estudiante/:datos',
    loadChildren: () =>
      import(
        './paginas/indicadores-asignatura-estudiante/indicadores-asignatura-estudiante.module'
      ).then((m) => m.IndicadoresAsignaturaEstudiantePageModule),
      canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'adm-indicadores-logro',
    loadChildren: () =>
      import(
        './paginas/adm-indicadores-logro/adm-indicadores-logro.module'
      ).then((m) => m.AdmIndicadoresLogroPageModule),
      canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'adm-idl-categorias',
    loadChildren: () =>
      import('./paginas/adm-idl-categorias/adm-idl-categorias.module').then(
        (m) => m.AdmIDLCategoriasPageModule
      ),
      canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  {
    path: 'adm-idl-usuarios',
    loadChildren: () =>
      import('./paginas/adm-idl-usuarios/adm-idl-usuarios.module').then(
        (m) => m.AdmIdlUsuariosPageModule
      ),
      canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'reporte-indicadores-logro-estudiante/:ids/:idanio',
    loadChildren: () => import('./paginas/reporte-indicadores-logro-estudiante/reporte-indicadores-logro-estudiante.module').then( m => m.ReporteIndicadoresLogroEstudiantePageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },


  {
    path: 'play-lab',
    loadChildren: () => import('./paginas/play-lab/play-lab.module').then( m => m.PlayLabPageModule)
  },
  {
    path: 'adm-rp-usuarios',
    loadChildren: () => import('./paginas/adm-rp-usuarios/adm-rp-usuarios.module').then( m => m.AdmRpUsuariosPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'llenar-reportes-progreso',
    loadChildren: () => import('./paginas/llenar-reportes-progreso/llenar-reportes-progreso.module').then( m => m.LlenarReportesProgresoPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  {
    path: 'llenar-reportes-progreso/:datos',
    loadChildren: () => import('./paginas/llenar-reportes-progreso/llenar-reportes-progreso.module').then( m => m.LlenarReportesProgresoPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  
  {
    path: 'reportes-progreso-secciones',
    loadChildren: () => import('./paginas/reportes-progreso-secciones/reportes-progreso-secciones.module').then( m => m.ReportesProgresoSeccionesPageModule)
  },

  {
    path: 'reportes-progreso-seccion/:datos',
    loadChildren: () => import('./paginas/reportes-progreso-seccion/reportes-progreso-seccion.module').then( m => m.ReportesProgresoSeccionPageModule)
  },

  {
    path: 'reporte-reportes-progreso-estudiantes/:Inscripciones',
    loadChildren: () => import('./paginas/reporte-reportes-progreso-estudiantes/reporte-reportes-progreso-estudiantes.module').then( m => m.ReporteReportesProgresoEstudiantesPageModule)
  },

  {
    path: 'reporte-indicadores-vacio/:Info',
    loadChildren: () => import('./paginas/reporte-indicadores-vacio/reporte-indicadores-vacio.module').then( m => m.ReporteIndicadoresVacioPageModule), 
    canActivate: [SessionOnGuard]
  },

  {
    path: 'indicadores-logros-profesores',
    loadChildren: () => import('./paginas/indicadores-logros-profesores/indicadores-logros-profesores.module').then( m => m.IndicadoresLogrosProfesoresPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },
  
  {
    path: 'indicadores-logros-profesor/:Info',
    loadChildren: () => import('./paginas/indicadores-logros-profesor/indicadores-logros-profesor.module').then( m => m.IndicadoresLogrosProfesorPageModule),
    canActivate: [SessionOnGuard, VerificarPrivilegiosGuard],
  },

  { path: '**', redirectTo: '/404' },




];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      useHash: false,
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
